import { jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const PageFooter = ({ children, className, classes, fixed }) => {
  const { themeClasses } = useThemePresetClasses("PageFooter", classes, className);
  return /* @__PURE__ */ jsx(
    "footer",
    {
      className: cn("flex-shrink-0", themeClasses == null ? void 0 : themeClasses.root, {
        "fixed bottom-0 left-0 h-fit w-full": fixed
      }),
      children
    }
  );
};
const PageFooter$1 = PageFooter;
export {
  PageFooter$1 as default
};
